import * as ae from "react";
import rt, { forwardRef as tt, useContext as nt, useMemo as at, useState as Bt, useEffect as qt } from "react";
import { css as z, createElement as Gt } from "@emotion/react";
import { zIndex as ot, globalColor as fe, illaPrefix as le, getColor as ye, applyBoxStyle as Ht, deleteCssProps as Jt } from "@illa-design/theme";
import { Button as jr } from "@illa-design/button";
import { ConfigProviderContext as Kt, def as Xt } from "@illa-design/config-provider";
import { WarningCircleIcon as Zt, SuccessCircleIcon as Qt, ErrorCircleIcon as en, InfoCircleIcon as rn, CloseIcon as tn } from "@illa-design/icon";
import { TriggerProvider as nn } from "@illa-design/trigger";
import { AnimatePresence as an, motion as Lr } from "framer-motion";
import on from "react-focus-lock";
import { useHotkeys as sn } from "react-hotkeys-hook";
import { v4 as it } from "uuid";
import { omit as cn } from "@illa-design/system";
var pr = { exports: {} }, ke = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yr;
function un() {
  if (Yr)
    return ke;
  Yr = 1;
  var e = rt, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, v) {
    var d, y = {}, A = null, $ = null;
    v !== void 0 && (A = "" + v), p.key !== void 0 && (A = "" + p.key), p.ref !== void 0 && ($ = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: f, key: A, ref: $, props: y, _owner: o.current };
  }
  return ke.Fragment = n, ke.jsx = l, ke.jsxs = l, ke;
}
var $e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function fn() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = rt, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), $ = Symbol.for("react.offscreen"), T = Symbol.iterator, b = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = T && t[T] || t[b];
      return typeof s == "function" ? s : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        O("error", t, u);
      }
    }
    function O(t, s, u) {
      {
        var m = _.ReactDebugCurrentFrame, C = m.getStackAddendum();
        C !== "" && (s += "%s", u = u.concat([C]));
        var N = u.map(function(S) {
          return String(S);
        });
        N.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, N);
      }
    }
    var I = !1, c = !1, F = !1, E = !1, oe = !1, ie;
    ie = Symbol.for("react.module.reference");
    function ce(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || oe || t === o || t === v || t === d || E || t === $ || I || c || F || typeof t == "object" && t !== null && (t.$$typeof === A || t.$$typeof === y || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === ie || t.getModuleId !== void 0));
    }
    function xe(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var C = s.displayName || s.name || "";
      return C !== "" ? u + "(" + C + ")" : u;
    }
    function se(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return se(s) + ".Consumer";
          case l:
            var u = t;
            return se(u._context) + ".Provider";
          case p:
            return xe(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : B(t.type) || "Memo";
          case A: {
            var C = t, N = C._payload, S = C._init;
            try {
              return B(S(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ee = 0, X, _e, Se, Ye, Ce, Ve, ze;
    function We() {
    }
    We.__reactDisabledLog = !0;
    function nr() {
      {
        if (ee === 0) {
          X = console.log, _e = console.info, Se = console.warn, Ye = console.error, Ce = console.group, Ve = console.groupCollapsed, ze = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: We,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function ar() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, t, {
              value: X
            }),
            info: K({}, t, {
              value: _e
            }),
            warn: K({}, t, {
              value: Se
            }),
            error: K({}, t, {
              value: Ye
            }),
            group: K({}, t, {
              value: Ce
            }),
            groupCollapsed: K({}, t, {
              value: Ve
            }),
            groupEnd: K({}, t, {
              value: ze
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = _.ReactCurrentDispatcher, Re;
    function de(t, s, u) {
      {
        if (Re === void 0)
          try {
            throw Error();
          } catch (C) {
            var m = C.stack.trim().match(/\n( *(at )?)/);
            Re = m && m[1] || "";
          }
        return `
` + Re + t;
      }
    }
    var Te = !1, pe;
    {
      var or = typeof WeakMap == "function" ? WeakMap : Map;
      pe = new or();
    }
    function h(t, s) {
      if (!t || Te)
        return "";
      {
        var u = pe.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      Te = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = we.current, we.current = null, nr();
      try {
        if (s) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              m = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              m = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            m = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && m && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), U = m.stack.split(`
`), D = x.length - 1, j = U.length - 1; D >= 1 && j >= 0 && x[D] !== U[j]; )
            j--;
          for (; D >= 1 && j >= 0; D--, j--)
            if (x[D] !== U[j]) {
              if (D !== 1 || j !== 1)
                do
                  if (D--, j--, j < 0 || x[D] !== U[j]) {
                    var J = `
` + x[D].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && pe.set(t, J), J;
                  }
                while (D >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        Te = !1, we.current = N, ar(), Error.prepareStackTrace = C;
      }
      var me = t ? t.displayName || t.name : "", Fr = me ? de(me) : "";
      return typeof t == "function" && pe.set(t, Fr), Fr;
    }
    function Oe(t, s, u) {
      return h(t, !1);
    }
    function he(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ue(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, he(t));
      if (typeof t == "string")
        return de(t);
      switch (t) {
        case v:
          return de("Suspense");
        case d:
          return de("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return Oe(t.render);
          case y:
            return ue(t.type, s, u);
          case A: {
            var m = t, C = m._payload, N = m._init;
            try {
              return ue(N(C), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var Ue = Object.prototype.hasOwnProperty, wr = {}, Rr = _.ReactDebugCurrentFrame;
    function Be(t) {
      if (t) {
        var s = t._owner, u = ue(t.type, t._source, s ? s.type : null);
        Rr.setExtraStackFrame(u);
      } else
        Rr.setExtraStackFrame(null);
    }
    function wt(t, s, u, m, C) {
      {
        var N = Function.call.bind(Ue);
        for (var S in t)
          if (N(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var U = Error((m || "React class") + ": " + u + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw U.name = "Invariant Violation", U;
              }
              x = t[S](s, S, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              x = D;
            }
            x && !(x instanceof Error) && (Be(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, S, typeof x), Be(null)), x instanceof Error && !(x.message in wr) && (wr[x.message] = !0, Be(C), g("Failed %s type: %s", u, x.message), Be(null));
          }
      }
    }
    var Rt = Array.isArray;
    function ir(t) {
      return Rt(t);
    }
    function Tt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function Ot(t) {
      try {
        return Tr(t), !1;
      } catch {
        return !0;
      }
    }
    function Tr(t) {
      return "" + t;
    }
    function Or(t) {
      if (Ot(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Tt(t)), Tr(t);
    }
    var Pe = _.ReactCurrentOwner, Pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pr, kr, sr;
    sr = {};
    function kt(t) {
      if (Ue.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function $t(t) {
      if (Ue.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function At(t, s) {
      if (typeof t.ref == "string" && Pe.current && s && Pe.current.stateNode !== s) {
        var u = B(Pe.current.type);
        sr[u] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Pe.current.type), t.ref), sr[u] = !0);
      }
    }
    function Nt(t, s) {
      {
        var u = function() {
          Pr || (Pr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function It(t, s) {
      {
        var u = function() {
          kr || (kr = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Mt = function(t, s, u, m, C, N, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: S,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Dt(t, s, u, m, C) {
      {
        var N, S = {}, x = null, U = null;
        u !== void 0 && (Or(u), x = "" + u), $t(s) && (Or(s.key), x = "" + s.key), kt(s) && (U = s.ref, At(s, C));
        for (N in s)
          Ue.call(s, N) && !Pt.hasOwnProperty(N) && (S[N] = s[N]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (N in D)
            S[N] === void 0 && (S[N] = D[N]);
        }
        if (x || U) {
          var j = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && Nt(S, j), U && It(S, j);
        }
        return Mt(t, x, U, C, m, Pe.current, S);
      }
    }
    var cr = _.ReactCurrentOwner, $r = _.ReactDebugCurrentFrame;
    function ve(t) {
      if (t) {
        var s = t._owner, u = ue(t.type, t._source, s ? s.type : null);
        $r.setExtraStackFrame(u);
      } else
        $r.setExtraStackFrame(null);
    }
    var ur;
    ur = !1;
    function fr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Ar() {
      {
        if (cr.current) {
          var t = B(cr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Ft(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Nr = {};
    function jt(t) {
      {
        var s = Ar();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Ir(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = jt(s);
        if (Nr[u])
          return;
        Nr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== cr.current && (m = " It was passed a child from " + B(t._owner.type) + "."), ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ve(null);
      }
    }
    function Mr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (ir(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            fr(m) && Ir(m, s);
          }
        else if (fr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = M(t);
          if (typeof C == "function" && C !== t.entries)
            for (var N = C.call(t), S; !(S = N.next()).done; )
              fr(S.value) && Ir(S.value, s);
        }
      }
    }
    function Lt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = B(s);
          wt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !ur) {
          ur = !0;
          var C = B(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Yt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ve(null);
            break;
          }
        }
        t.ref !== null && (ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), ve(null));
      }
    }
    function Dr(t, s, u, m, C, N) {
      {
        var S = ce(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var U = Ft(C);
          U ? x += U : x += Ar();
          var D;
          t === null ? D = "null" : ir(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (B(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, x);
        }
        var j = Dt(t, s, u, C, N);
        if (j == null)
          return j;
        if (S) {
          var J = s.children;
          if (J !== void 0)
            if (m)
              if (ir(J)) {
                for (var me = 0; me < J.length; me++)
                  Mr(J[me], t);
                Object.freeze && Object.freeze(J);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Mr(J, t);
        }
        return t === a ? Yt(j) : Lt(j), j;
      }
    }
    function Vt(t, s, u) {
      return Dr(t, s, u, !0);
    }
    function zt(t, s, u) {
      return Dr(t, s, u, !1);
    }
    var Wt = zt, Ut = Vt;
    $e.Fragment = a, $e.jsx = Wt, $e.jsxs = Ut;
  }()), $e;
}
process.env.NODE_ENV === "production" ? pr.exports = un() : pr.exports = fn();
var Me = pr.exports;
function ln(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function dn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var pn = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(dn(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = ln(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), W = "-ms-", Xe = "-moz-", w = "-webkit-", Er = "comm", br = "rule", xr = "decl", hn = "@import", st = "@keyframes", vn = "@layer", mn = Math.abs, Qe = String.fromCharCode, yn = Object.assign;
function gn(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function ct(e) {
  return e.trim();
}
function En(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function R(e, r, n) {
  return e.replace(r, n);
}
function hr(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function De(e, r, n) {
  return e.slice(r, n);
}
function re(e) {
  return e.length;
}
function _r(e) {
  return e.length;
}
function qe(e, r) {
  return r.push(e), e;
}
function bn(e, r) {
  return e.map(r).join("");
}
var er = 1, Ee = 1, ut = 0, G = 0, Y = 0, be = "";
function rr(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: er, column: Ee, length: l, return: "" };
}
function Ae(e, r) {
  return yn(rr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function xn() {
  return Y;
}
function _n() {
  return Y = G > 0 ? V(be, --G) : 0, Ee--, Y === 10 && (Ee = 1, er--), Y;
}
function H() {
  return Y = G < ut ? V(be, G++) : 0, Ee++, Y === 10 && (Ee = 1, er++), Y;
}
function te() {
  return V(be, G);
}
function He() {
  return G;
}
function Le(e, r) {
  return De(be, e, r);
}
function Fe(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ft(e) {
  return er = Ee = 1, ut = re(be = e), G = 0, [];
}
function lt(e) {
  return be = "", e;
}
function Je(e) {
  return ct(Le(G - 1, vr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Sn(e) {
  for (; (Y = te()) && Y < 33; )
    H();
  return Fe(e) > 2 || Fe(Y) > 3 ? "" : " ";
}
function Cn(e, r) {
  for (; --r && H() && !(Y < 48 || Y > 102 || Y > 57 && Y < 65 || Y > 70 && Y < 97); )
    ;
  return Le(e, He() + (r < 6 && te() == 32 && H() == 32));
}
function vr(e) {
  for (; H(); )
    switch (Y) {
      case e:
        return G;
      case 34:
      case 39:
        e !== 34 && e !== 39 && vr(Y);
        break;
      case 40:
        e === 41 && vr(e);
        break;
      case 92:
        H();
        break;
    }
  return G;
}
function wn(e, r) {
  for (; H() && e + Y !== 47 + 10; )
    if (e + Y === 42 + 42 && te() === 47)
      break;
  return "/*" + Le(r, G - 1) + "*" + Qe(e === 47 ? e : H());
}
function Rn(e) {
  for (; !Fe(te()); )
    H();
  return Le(e, G);
}
function Tn(e) {
  return lt(Ke("", null, null, null, [""], e = ft(e), 0, [0], e));
}
function Ke(e, r, n, a, o, i, l, f, p) {
  for (var v = 0, d = 0, y = l, A = 0, $ = 0, T = 0, b = 1, M = 1, _ = 1, g = 0, O = "", I = o, c = i, F = a, E = O; M; )
    switch (T = g, g = H()) {
      case 40:
        if (T != 108 && V(E, y - 1) == 58) {
          hr(E += R(Je(g), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        E += Je(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        E += Sn(T);
        break;
      case 92:
        E += Cn(He() - 1, 7);
        continue;
      case 47:
        switch (te()) {
          case 42:
          case 47:
            qe(On(wn(H(), He()), r, n), p);
            break;
          default:
            E += "/";
        }
        break;
      case 123 * b:
        f[v++] = re(E) * _;
      case 125 * b:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            _ == -1 && (E = R(E, /\f/g, "")), $ > 0 && re(E) - y && qe($ > 32 ? Wr(E + ";", a, n, y - 1) : Wr(R(E, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            E += ";";
          default:
            if (qe(F = zr(E, r, n, v, d, o, f, O, I = [], c = [], y), i), g === 123)
              if (d === 0)
                Ke(E, r, F, F, I, i, y, f, c);
              else
                switch (A === 99 && V(E, 3) === 110 ? 100 : A) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ke(e, F, F, a && qe(zr(e, F, F, 0, 0, o, f, O, o, I = [], y), c), o, c, y, f, a ? I : c);
                    break;
                  default:
                    Ke(E, F, F, F, [""], c, 0, f, c);
                }
        }
        v = d = $ = 0, b = _ = 1, O = E = "", y = l;
        break;
      case 58:
        y = 1 + re(E), $ = T;
      default:
        if (b < 1) {
          if (g == 123)
            --b;
          else if (g == 125 && b++ == 0 && _n() == 125)
            continue;
        }
        switch (E += Qe(g), g * b) {
          case 38:
            _ = d > 0 ? 1 : (E += "\f", -1);
            break;
          case 44:
            f[v++] = (re(E) - 1) * _, _ = 1;
            break;
          case 64:
            te() === 45 && (E += Je(H())), A = te(), d = y = re(O = E += Rn(He())), g++;
            break;
          case 45:
            T === 45 && re(E) == 2 && (b = 0);
        }
    }
  return i;
}
function zr(e, r, n, a, o, i, l, f, p, v, d) {
  for (var y = o - 1, A = o === 0 ? i : [""], $ = _r(A), T = 0, b = 0, M = 0; T < a; ++T)
    for (var _ = 0, g = De(e, y + 1, y = mn(b = l[T])), O = e; _ < $; ++_)
      (O = ct(b > 0 ? A[_] + " " + g : R(g, /&\f/g, A[_]))) && (p[M++] = O);
  return rr(e, r, n, o === 0 ? br : f, p, v, d);
}
function On(e, r, n) {
  return rr(e, r, n, Er, Qe(xn()), De(e, 2, -2), 0);
}
function Wr(e, r, n, a) {
  return rr(e, r, n, xr, De(e, 0, a), De(e, a + 1, -1), a);
}
function ge(e, r) {
  for (var n = "", a = _r(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function Pn(e, r, n, a) {
  switch (e.type) {
    case vn:
      if (e.children.length)
        break;
    case hn:
    case xr:
      return e.return = e.return || e.value;
    case Er:
      return "";
    case st:
      return e.return = e.value + "{" + ge(e.children, a) + "}";
    case br:
      e.value = e.props.join(",");
  }
  return re(n = ge(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function kn(e) {
  var r = _r(e);
  return function(n, a, o, i) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, a, o, i) || "";
    return l;
  };
}
function $n(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function An(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Nn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = te(), o === 38 && i === 12 && (n[a] = 1), !Fe(i); )
    H();
  return Le(r, G);
}, In = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Fe(o)) {
      case 0:
        o === 38 && te() === 12 && (n[a] = 1), r[a] += Nn(G - 1, n, a);
        break;
      case 2:
        r[a] += Je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = te() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Qe(o);
    }
  while (o = H());
  return r;
}, Mn = function(r, n) {
  return lt(In(ft(r), n));
}, Ur = /* @__PURE__ */ new WeakMap(), Dn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Ur.get(a)) && !o) {
      Ur.set(r, !0);
      for (var i = [], l = Mn(n, i), f = a.props, p = 0, v = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, v++)
          r.props[v] = i[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, Fn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, jn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Ln = function(r) {
  return r.type === "comm" && r.children.indexOf(jn) > -1;
}, Yn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = f.length - 1; p >= 0; p--) {
          var v = f[p];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (Ln(v))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, dt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Vn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!dt(n[a]))
      return !0;
  return !1;
}, Br = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, zn = function(r, n, a) {
  dt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Br(r)) : Vn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Br(r)));
};
function pt(e, r) {
  switch (gn(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + Xe + e + W + e + e;
    case 6828:
    case 4268:
      return w + e + W + e + e;
    case 6165:
      return w + e + W + "flex-" + e + e;
    case 5187:
      return w + e + R(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + W + "flex-$1$2") + e;
    case 5443:
      return w + e + W + "flex-item-" + R(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + W + "flex-line-pack" + R(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + W + R(e, "shrink", "negative") + e;
    case 5292:
      return w + e + W + R(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + R(e, "-grow", "") + w + e + W + R(e, "grow", "positive") + e;
    case 4554:
      return w + R(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return R(R(R(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return R(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return R(R(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + W + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return R(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (re(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return R(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + Xe + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~hr(e, "stretch") ? pt(R(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, re(e) - 3 - (~hr(e, "!important") && 10))) {
        case 107:
          return R(e, ":", ":" + w) + e;
        case 101:
          return R(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + W + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return w + e + W + R(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + W + R(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + W + R(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + W + e + e;
  }
  return e;
}
var Wn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case xr:
        r.return = pt(r.value, r.length);
        break;
      case st:
        return ge([Ae(r, {
          value: R(r.value, "@", "@" + w)
        })], o);
      case br:
        if (r.length)
          return bn(r.props, function(i) {
            switch (En(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ge([Ae(r, {
                  props: [R(i, /:(read-\w+)/, ":" + Xe + "$1")]
                })], o);
              case "::placeholder":
                return ge([Ae(r, {
                  props: [R(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), Ae(r, {
                  props: [R(i, /:(plac\w+)/, ":" + Xe + "$1")]
                }), Ae(r, {
                  props: [R(i, /:(plac\w+)/, W + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Un = [Wn], Bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var M = b.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Un;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var M = b.getAttribute("data-emotion").split(" "), _ = 1; _ < M.length; _++)
        i[M[_]] = !0;
      f.push(b);
    }
  );
  var p, v = [Dn, Fn];
  process.env.NODE_ENV !== "production" && v.push(Yn({
    get compat() {
      return T.compat;
    }
  }), zn);
  {
    var d, y = [Pn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== Er && d.insert(b.value + "{}"));
    } : $n(function(b) {
      d.insert(b);
    })], A = kn(v.concat(o, y)), $ = function(M) {
      return ge(Tn(M), A);
    };
    p = function(M, _, g, O) {
      d = g, process.env.NODE_ENV !== "production" && _.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + _.map);
        }
      }), $(M ? M + "{" + _.styles + "}" : _.styles), O && (T.inserted[_.name] = !0);
    };
  }
  var T = {
    key: n,
    sheet: new pn({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return T.sheet.hydrate(f), T;
}, mr = { exports: {} }, P = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function qn() {
  if (qr)
    return P;
  qr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function O(c) {
    if (typeof c == "object" && c !== null) {
      var F = c.$$typeof;
      switch (F) {
        case r:
          switch (c = c.type, c) {
            case p:
            case v:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case T:
                case $:
                case l:
                  return c;
                default:
                  return F;
              }
          }
        case n:
          return F;
      }
    }
  }
  function I(c) {
    return O(c) === v;
  }
  return P.AsyncMode = p, P.ConcurrentMode = v, P.ContextConsumer = f, P.ContextProvider = l, P.Element = r, P.ForwardRef = d, P.Fragment = a, P.Lazy = T, P.Memo = $, P.Portal = n, P.Profiler = i, P.StrictMode = o, P.Suspense = y, P.isAsyncMode = function(c) {
    return I(c) || O(c) === p;
  }, P.isConcurrentMode = I, P.isContextConsumer = function(c) {
    return O(c) === f;
  }, P.isContextProvider = function(c) {
    return O(c) === l;
  }, P.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, P.isForwardRef = function(c) {
    return O(c) === d;
  }, P.isFragment = function(c) {
    return O(c) === a;
  }, P.isLazy = function(c) {
    return O(c) === T;
  }, P.isMemo = function(c) {
    return O(c) === $;
  }, P.isPortal = function(c) {
    return O(c) === n;
  }, P.isProfiler = function(c) {
    return O(c) === i;
  }, P.isStrictMode = function(c) {
    return O(c) === o;
  }, P.isSuspense = function(c) {
    return O(c) === y;
  }, P.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === i || c === o || c === y || c === A || typeof c == "object" && c !== null && (c.$$typeof === T || c.$$typeof === $ || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === M || c.$$typeof === _ || c.$$typeof === g || c.$$typeof === b);
  }, P.typeOf = O, P;
}
var k = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gr;
function Gn() {
  return Gr || (Gr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, A = e ? Symbol.for("react.suspense_list") : 60120, $ = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function O(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === y || h === A || typeof h == "object" && h !== null && (h.$$typeof === T || h.$$typeof === $ || h.$$typeof === l || h.$$typeof === f || h.$$typeof === d || h.$$typeof === M || h.$$typeof === _ || h.$$typeof === g || h.$$typeof === b);
    }
    function I(h) {
      if (typeof h == "object" && h !== null) {
        var Oe = h.$$typeof;
        switch (Oe) {
          case r:
            var he = h.type;
            switch (he) {
              case p:
              case v:
              case a:
              case i:
              case o:
              case y:
                return he;
              default:
                var ue = he && he.$$typeof;
                switch (ue) {
                  case f:
                  case d:
                  case T:
                  case $:
                  case l:
                    return ue;
                  default:
                    return Oe;
                }
            }
          case n:
            return Oe;
        }
      }
    }
    var c = p, F = v, E = f, oe = l, ie = r, ce = d, xe = a, se = T, B = $, K = n, ee = i, X = o, _e = y, Se = !1;
    function Ye(h) {
      return Se || (Se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Ce(h) || I(h) === p;
    }
    function Ce(h) {
      return I(h) === v;
    }
    function Ve(h) {
      return I(h) === f;
    }
    function ze(h) {
      return I(h) === l;
    }
    function We(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function nr(h) {
      return I(h) === d;
    }
    function ar(h) {
      return I(h) === a;
    }
    function we(h) {
      return I(h) === T;
    }
    function Re(h) {
      return I(h) === $;
    }
    function de(h) {
      return I(h) === n;
    }
    function Te(h) {
      return I(h) === i;
    }
    function pe(h) {
      return I(h) === o;
    }
    function or(h) {
      return I(h) === y;
    }
    k.AsyncMode = c, k.ConcurrentMode = F, k.ContextConsumer = E, k.ContextProvider = oe, k.Element = ie, k.ForwardRef = ce, k.Fragment = xe, k.Lazy = se, k.Memo = B, k.Portal = K, k.Profiler = ee, k.StrictMode = X, k.Suspense = _e, k.isAsyncMode = Ye, k.isConcurrentMode = Ce, k.isContextConsumer = Ve, k.isContextProvider = ze, k.isElement = We, k.isForwardRef = nr, k.isFragment = ar, k.isLazy = we, k.isMemo = Re, k.isPortal = de, k.isProfiler = Te, k.isStrictMode = pe, k.isSuspense = or, k.isValidElementType = O, k.typeOf = I;
  }()), k;
}
process.env.NODE_ENV === "production" ? mr.exports = qn() : mr.exports = Gn();
var Hn = mr.exports, ht = Hn, Jn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Kn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, vt = {};
vt[ht.ForwardRef] = Jn;
vt[ht.Memo] = Kn;
var Xn = !0;
function Zn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var mt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Xn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Qn = function(r, n, a) {
  mt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function ea(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var ra = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Hr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, ta = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", na = /[A-Z]|^ms/g, yt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Sr = function(r) {
  return r.charCodeAt(1) === 45;
}, Jr = function(r) {
  return r != null && typeof r != "boolean";
}, lr = /* @__PURE__ */ An(function(e) {
  return Sr(e) ? e : e.replace(na, "-$&").toLowerCase();
}), Ze = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(yt, function(a, o, i) {
          return Z = {
            name: o,
            styles: i,
            next: Z
          }, o;
        });
  }
  return ra[r] !== 1 && !Sr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var aa = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, oa = ["normal", "none", "initial", "inherit", "unset"], ia = Ze, sa = /^-ms-/, ca = /-(.)/g, Kr = {};
  Ze = function(r, n) {
    if (r === "content" && (typeof n != "string" || oa.indexOf(n) === -1 && !aa.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = ia(r, n);
    return a !== "" && !Sr(r) && r.indexOf("-") !== -1 && Kr[r] === void 0 && (Kr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(sa, "ms-").replace(ca, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var gt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function je(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(gt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Z = {
          name: n.name,
          styles: n.styles,
          next: Z
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Z = {
              name: a.name,
              styles: a.styles,
              next: Z
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return ua(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = Z, l = n(e);
        return Z = i, je(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(yt, function(d, y, A) {
          var $ = "animation" + f.length;
          return f.push("const " + $ + " = keyframes`" + A.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + $ + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function ua(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += je(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Jr(l) && (a += lr(i) + ":" + Ze(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(gt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Jr(l[f]) && (a += lr(i) + ":" + Ze(i, l[f]) + ";");
        else {
          var p = je(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += lr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(ta), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Xr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Et;
process.env.NODE_ENV !== "production" && (Et = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Z, Zr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  Z = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += je(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Hr), i += l[0]);
  for (var f = 1; f < r.length; f++)
    i += je(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(Hr), i += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(Et, function(A) {
    return p = A, "";
  })), Xr.lastIndex = 0;
  for (var v = "", d; (d = Xr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = ea(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: Z,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: Z
  };
}, fa = function(r) {
  return r();
}, la = ae["useInsertionEffect"] ? ae["useInsertionEffect"] : !1, da = la || fa, tr = {}.hasOwnProperty, Cr = /* @__PURE__ */ ae.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Cr.displayName = "EmotionCacheContext");
Cr.Provider;
var pa = function(r) {
  return /* @__PURE__ */ tt(function(n, a) {
    var o = nt(Cr);
    return r(n, o, a);
  });
}, bt = /* @__PURE__ */ ae.createContext({});
process.env.NODE_ENV !== "production" && (bt.displayName = "EmotionThemeContext");
var Qr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, ha = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Qr(n[1]);
}, va = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ma = function(r) {
  return r.replace(/\$/g, "-");
}, ya = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = ha(n[a]);
      if (o) {
        if (va.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ma(o);
      }
    }
}, yr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", gr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", xt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    tr.call(n, o) && (a[o] = n[o]);
  if (a[yr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = ya(new Error().stack);
    i && (a[gr] = i);
  }
  return a;
}, ga = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return mt(n, a, o), da(function() {
    return Qn(n, a, o);
  }), null;
}, _t = /* @__PURE__ */ pa(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[yr], i = [a], l = "";
  typeof e.className == "string" ? l = Zn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var f = Zr(i, void 0, ae.useContext(bt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[gr];
    p && (f = Zr([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var v = {};
  for (var d in e)
    tr.call(e, d) && d !== "css" && d !== yr && (process.env.NODE_ENV === "production" || d !== gr) && (v[d] = e[d]);
  return v.ref = n, v.className = l, /* @__PURE__ */ ae.createElement(ae.Fragment, null, /* @__PURE__ */ ae.createElement(ga, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ae.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (_t.displayName = "EmotionCssPropInternal");
var St = _t, Ie = Me.Fragment;
function L(e, r, n) {
  return tr.call(r, "css") ? Me.jsx(St, xt(e, r), n) : Me.jsx(e, r, n);
}
function Ge(e, r, n) {
  return tr.call(r, "css") ? Me.jsxs(St, xt(e, r), n) : Me.jsxs(e, r, n);
}
const Ea = z`
  z-index: ${ot.modal};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${fe(`--${le}-blackAlpha-04`)};
`, ba = z`
  position: fixed;
  cursor: auto;
  overflow: auto;
  text-align: center;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: ${ot.modal};
  &:after {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%;
    content: "";
  }
`;
function xa() {
  return z`
    box-sizing: content-box;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    text-align: left;
    min-width: 520px;
    width: 520px;
    margin: 24px auto;
    border-radius: 8px;
    border: 1px solid ${fe(`--${le}-grayBlue-08`)};
    background-color: ${fe(`--${le}-white-01`)};
  `;
}
function _a(e, r) {
  let n = z``;
  r || (n = z`
      border-bottom: 1px solid ${fe(`--${le}-grayBlue-08`)};
    `);
  const a = e ? z`
        padding: 16px 40px;
      ` : z`
        padding: 16px;
      `;
  return z`
    ${a};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    ${n};
  `;
}
function Sa() {
  return z`
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: ${fe(`--${le}-grayBlue-02`)};
  `;
}
function et(e) {
  const r = e ? z`
        padding: 0;
      ` : "";
  return z`
    font-size: 14px;
    color: ${ye("grayBlue", "02")};
    font-weight: 400;
    line-height: 22px;
    padding: 8px 24px;
    ${r}
  `;
}
const Ca = z`
  position: absolute;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  top: 16px;
  right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${fe(`--${le}-grayBlue-03`)};
`;
function wa(e, r) {
  const n = e ? z`
        text-align: ${e};
      ` : "", a = r ? z`` : z`
        border-top: 1px solid ${fe(`--${le}-grayBlue-08`)};
      `;
  return z`
    text-align: right;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 24px;
    ${a};
    ${n};
  `;
}
const Ra = z`
  margin-right: 8px;
`, Ta = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, Oa = {
  initial: {
    opacity: 0,
    scaleX: 0.5,
    scaleY: 0.5
  },
  animate: {
    opacity: 1,
    scaleX: 1,
    scaleY: 1
  },
  exit: {
    opacity: 0,
    scaleX: 0.5,
    scaleY: 0.5
  }
}, Ct = tt((e, r) => {
  var ee;
  const { withoutPadding: n, children: a, visible: o, type: i, mask: l = !0, title: f, withoutLine: p = !0, okLoading: v, maskClosable: d = !0, maskStyle: y, hideCancel: A, closable: $, closeElement: T, okText: b, cancelText: M, okButtonProps: _, cancelButtonProps: g, footer: O = !0, footerAlign: I = "", focusLock: c = !0, autoFocus: F = !0, onCancel: E, onOk: oe, afterClose: ie, afterOpen: ce, ...xe } = e, se = nt(Kt), B = ((ee = se == null ? void 0 : se.locale) == null ? void 0 : ee.modal) ?? Xt.modal;
  sn("Enter,Escape", (X, _e) => {
    switch (X.key) {
      case "Enter":
        o && (oe == null || oe());
        break;
      case "Escape":
        o && (E == null || E());
        break;
    }
  }, {
    enableOnFormTags: ["INPUT"]
  }, [o]);
  const K = at(() => {
    if (i && f)
      switch (i) {
        case "info":
          return L(rn, { fs: "16px", mr: "8px", c: ye("blue", "03") });
        case "error":
          return L(en, { fs: "16px", mr: "8px", c: ye("red", "03") });
        case "success":
          return L(Qt, { fs: "16px", mr: "8px", c: ye("green", "03") });
        case "warning":
          return L(Zt, { fs: "16px", mr: "8px", c: ye("red", "03") });
        default:
          return L(Ie, {});
      }
    else
      return L(Ie, {});
  }, [f, i]);
  return L(nn, { renderInBody: !1, zIndex: 10, children: L(an, { children: o && Ge(Ie, { children: [l ? L(Lr.div, { css: [Ea, y], variants: Ta, animate: "animate", exit: "exit", initial: "initial", transition: { duration: 0.2 } }) : null, L("div", { css: ba, onClick: () => {
    d && (E == null || E());
  }, children: Ge(Lr.div, { onClick: (X) => {
    X.stopPropagation();
  }, ref: r, role: "dialog", variants: Oa, animate: "animate", transition: { duration: 0.2 }, exit: "exit", initial: "initial", css: [xa(), Ht(e)], onAnimationComplete: (X) => {
    X === "animate" && (ce == null || ce()), X === "exit" && (ie == null || ie());
  }, ...Jt(xe), children: [f && Ge("div", { css: _a($, p), children: [K, L("div", { css: Sa(), children: f }), $ && L(Ie, { children: T || L("div", { css: Ca, onClick: E, children: L(tn, { size: "14px", c: ye("grayBlue", "02") }) }) })] }), c ? L(on, { disabled: !o, autoFocus: F, children: a && L("div", { css: et(n), children: a }) }) : a && L("div", { css: et(n), children: a }), O && Ge("div", { css: wa(I, p), children: [!A && L(jr, { css: Ra, onClick: E, colorScheme: "gray", size: "medium", ...g, children: M || B.cancelText }), L(jr, { loading: v, size: "medium", onClick: oe, ..._, children: b || B.okText })] })] }) })] }) }) });
});
Ct.displayName = "Modal";
const q = {
  listener: [],
  modals: []
};
function Pa() {
  return {
    getModals: () => q.modals,
    setModals: (e) => {
      q.modals = e, q.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    subscribe: (e) => {
      const r = {
        listenerId: it(),
        onStoreChange: e
      };
      return q.listener.push(r), r.onStoreChange(), r;
    },
    unSubscribe: (e) => {
      q.listener.splice(q.listener.findIndex((r) => r.listenerId === e), 1);
    },
    update: (e, r) => {
      const n = q.modals.findIndex((a) => a.id === e);
      n != -1 && (q.modals[n] = r, q.listener.forEach((a) => {
        a.onStoreChange();
      }));
    },
    add: (e) => {
      q.modals.push(e), q.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    remove: (e) => {
      const r = q.modals.findIndex((n) => n.id === e);
      r != -1 && (q.modals.splice(r, 1), q.listener.forEach((n) => {
        n.onStoreChange();
      }));
    }
  };
}
const Q = Pa(), Ne = (e) => (e.id || (e.id = it()), e.visible || (e.visible = !0), Q.add(e), e.id), dr = (e) => Q.getModals().find((r) => r.id === e), ka = {
  info: (e) => (e.type = "info", Ne(e)),
  error: (e) => (e.type = "error", Ne(e)),
  success: (e) => (e.type = "success", Ne(e)),
  warning: (e) => (e.type = "warning", Ne(e)),
  getModalById: dr,
  update: (e, r) => {
    Q.update(e, {
      ...dr(e),
      ...r
    });
  },
  close: (e) => {
    const r = dr(e);
    Q.update(e, {
      ...r,
      visible: !1,
      afterClose: () => {
        var n;
        (n = r == null ? void 0 : r.afterClose) == null || n.call(r), Q.remove(e);
      }
    });
  },
  show: Ne
};
function $a() {
  return ka;
}
const Ua = $a, Ba = () => {
  const [e, r] = Bt([]);
  qt(() => {
    const a = Q.subscribe(() => {
      r([...Q.getModals()]);
    });
    return () => {
      Q.unSubscribe(a.listenerId);
    };
  }, []);
  const n = at(() => e.map((a) => Gt(Ct, { ...cn(a, ["blockOkHide", "blockCancelHide"]), key: a.id, onCancel: () => {
    var o;
    (o = a.onCancel) == null || o.call(a), a.blockCancelHide != !0 && a.id && Q.update(a.id, {
      ...a,
      visible: !1
    });
  }, onOk: () => {
    var o;
    (o = a.onOk) == null || o.call(a), a.blockOkHide != !0 && a.id && Q.update(a.id, {
      ...a,
      visible: !1
    });
  }, afterClose: () => {
    var o;
    (o = a.afterClose) == null || o.call(a), a.id && Q.remove(a.id);
  } })), [e]);
  return L(Ie, { children: n });
};
export {
  Ct as Modal,
  Ba as ModalGroup,
  xa as applyModal,
  Ra as applyModalCancelBtn,
  ba as applyModalContainer,
  et as applyModalContent,
  wa as applyModalFooter,
  _a as applyModalHeader,
  Ea as applyModalMask,
  Sa as applyModalTitle,
  Ua as createModal,
  Ta as maskAnimation,
  Oa as modalAnimation,
  Ca as modalCloseIconStyle,
  $a as useModal
};
//# sourceMappingURL=index.js.map
